/* FANNUR v0.5 | Template registry: beheer layouts hier of via Shopify JSON-metafield */
(function () {
  'use strict';
  const themes = {
    'text-date': {
      id:'text-date', type:'text-only', name:'Bijzondere datum',
      background:'#dbd7d0', ink:'#ffffff', colors:['#dbd7d0','#292929','#f3f0ea','#b4ac9e'], inks:['#ffffff','#242424'],
      fonts:['modern-sans','classic-serif','dm-sans','playfair','shopify-heading','shopify-body'], font:'modern-sans',
      fontRoles:[{id:'heading',label:'Grote cijfers',default:'modern-sans'},{id:'detail',label:'Kleine gegevens',default:'modern-sans'}],
      fields:[
        {id:'day', label:'Dag', value:'15', max:2, numeric:true},
        {id:'month',label:'Maand',value:'02',max:2,numeric:true},
        {id:'year',label:'Jaar (2 cijfers)',value:'14',max:2,numeric:true},
        {id:'coordinates',label:'Coördinaten / locatie',value:'52°05′N 05°33′E',max:42},
        {id:'names',label:'Namen',value:'ANNA EN DANIEL',max:40}
      ],
      layout:'date'
    },
    'text-quote': {
      id:'text-quote',type:'text-only',name:'Quote poster',
      background:'#f6f1e7',ink:'#313932',colors:['#f6f1e7','#ffffff','#ded8d0','#cfd8d1'],inks:['#313932','#141414','#8b5d45'],
      fonts:['classic-serif','traditional-serif','modern-sans','playfair','cormorant','great-vibes','dm-sans','shopify-heading','shopify-body'],font:'classic-serif',
      fontRoles:[{id:'heading',label:'Hoofdtekst',default:'classic-serif'},{id:'detail',label:'Subtekst',default:'classic-serif'}],
      fields:[{id:'title',label:'Hoofdtekst',value:'Jouw bijzondere moment',max:70},
              {id:'subtitle',label:'Subtekst',value:'Een herinnering voor altijd',max:80}],
      layout:'quote'
    },
    'text-wedding': {
      id:'text-wedding',type:'text-only',name:'Wedding typografie',
      background:'#ffffff',ink:'#181818',colors:['#ffffff','#f7f3e9','#ded9d2','#161616'],inks:['#181818','#ffffff','#9b715e'],
      fonts:['classic-serif','traditional-serif','modern-sans','playfair','cormorant','great-vibes','dm-sans','shopify-heading','shopify-body'],font:'classic-serif',
      fontRoles:[{id:'heading',label:'Grote titel',default:'classic-serif',allowed:['classic-serif','traditional-serif','playfair','cormorant','shopify-heading']},
                 {id:'script',label:'Sierlijke namen',default:'classic-serif',allowed:['classic-serif','cormorant','great-vibes','playfair','shopify-heading']},
                 {id:'detail',label:'Kleine gegevens',default:'modern-sans',allowed:['modern-sans','dm-sans','classic-serif','shopify-body']}],
      fields:[{id:'heading',label:'Grote titel',value:'Mr & Mrs',max:20},
              {id:'names',label:'Namen',value:'EMILIA & SAMUEL',max:42},
              {id:'date',label:'Datum en plaats',value:'23 OKTOBER — STOCKHOLM 2017',max:55},
              {id:'coordinates',label:'GPS-coördinaten',value:'59°19′46″N 18°4′7″E',max:48}],
      layout:'wedding'
    },
    'text-jersey': {
      id:'text-jersey', type:'text-only', name:'Gepersonaliseerd voetbalshirt',
      background:'#123967', ink:'#ffffff', colors:['#123967'], inks:['#ffffff'],
      fonts:['modern-sans','shopify-heading','shopify-body'], font:'modern-sans',
      fontRoles:[{id:'name',label:'Naamlettertype',default:'modern-sans'},
                 {id:'number',label:'Nummerlettertype',default:'modern-sans'}],
      fields:[{id:'name',label:'Naam op het shirt',value:'YOUR NAME',max:15,uppercase:true,required:true},
              {id:'number',label:'Rugnummer',value:'21',max:2,numeric:true,required:true}],
      layout:'jersey', requiresBackground:true, lockedStyle:true
    },
    'photo-classic': {
      id:'photo-classic',type:'photo-upload',name:'Foto met onderschrift',
      background:'#f7f3e9',ink:'#302820',colors:['#f7f3e9','#fff','#e4dfd7','#242424'],inks:['#302820','#1b1b1b','#ffffff'],
      fonts:['classic-serif','modern-sans','traditional-serif','playfair','cormorant','dm-sans','shopify-heading','shopify-body'],font:'classic-serif',
      fontRoles:[{id:'heading',label:'Titel',default:'classic-serif'},{id:'detail',label:'Ondertitel',default:'classic-serif'}],
      fields:[{id:'title',label:'Titel',value:'Jouw bijzondere moment',max:70},
              {id:'subtitle',label:'Ondertitel',value:'Een herinnering voor altijd',max:80}],
      layout:'photo-classic',allowBorders:['none','thin','wide']
    },
    'photo-modern': {
      id:'photo-modern',type:'photo-upload',name:'Modern fotoportret',
      background:'#ffffff',ink:'#242424',colors:['#ffffff','#f0eae2','#292929','#d8d8d8'],inks:['#242424','#ffffff','#734e3c'],
      fonts:['modern-sans','classic-serif','playfair','dm-sans','cormorant','shopify-heading','shopify-body'],font:'modern-sans',
      fontRoles:[{id:'heading',label:'Titel',default:'modern-sans'},{id:'detail',label:'Ondertitel',default:'modern-sans'}],
      fields:[{id:'title',label:'Naam / titel',value:'ONS MOOISTE MOMENT',max:50},
              {id:'subtitle',label:'Datum / ondertitel',value:'20 OKTOBER 2026',max:50}],
      layout:'photo-modern',allowBorders:['none','thin','wide']
    }
  };
  // Niet live: exacte locatie/astronomie wordt als aparte module geïntegreerd.
  const planned = {
    'location-art':{type:'location-art',dependsOn:['geoapify-autocomplete','licensed-map-renderer'],status:'planned'},
    'moon-art':{type:'moon-art',dependsOn:['astronomy-engine','moon-visual-renderer'],status:'planned'},
    'star-map':{type:'star-map',dependsOn:['astronomy-engine','star-catalogue','sky-projection'],status:'planned'},
    'planets-aligned':{type:'planets-aligned',dependsOn:['astronomy-engine','planet-renderer'],status:'planned'}
  };
  window.FANNUR_TEMPLATES_V05 = Object.freeze(themes);
  window.FANNUR_PLANNED_V05 = Object.freeze(planned);
})();
